import { RegistryItem } from '../RegistryItem';
export class ActionRegistryItem extends RegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    action = () => { };
    scope;
    params;
}
